/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Team_Settings_Data_WriteInputs */



/**
* | output |
* | --- |
* | "Change timezone, bot language, data retention and recording exclusions" |
*
* @param {Perm_Team_Settings_Data_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_team_settings_data_write = /** @type {((inputs?: Perm_Team_Settings_Data_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Team_Settings_Data_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменять часовой пояс, язык бота, срок хранения данных и исключения из записи")
	return /** @type {LocalizedString} */ ("Change timezone, bot language, data retention and recording exclusions")
});